import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  toggleMenu = new Subject<void>();

  constructor() {}

  emitToggleMenu(): void {
    this.toggleMenu.next();
  }
}
